export const geoPickupQueryTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "placeName",
      Value: "String",
      Required: "true",
      Example: "London Heathrow International Airport (LHR)",
    },
    {
      Parameter: "email",
      Value: "String",
      Required: "true",
      Example: "abc@email.com (Enter the given Login Email)",
    },
  ],
};


export const geoDropoffQueryTab = {
  HeaderTable: ["Parameter", "Value", "Required", "Example"],
  HeaderBodyTable: [
    {
      Parameter: "placeName",
      Value: "String",
      Required: "true",
      Example: "Hilton London Metropole",
    },
    {
      Parameter: "email",
      Value: "String",
      Required: "true",
      Example: "abc@email.com (Enter the given Login Email)",
    },
  ],
};
